import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'


const RedeemSuccessModal = composeDialogModal({
  name: constants.modals.RedeemSuccess,
  title: messages.title,
  contentMessage: ({ giftSubscription: { giverName, months: monthsCount } }) => ({
    ...messages.text,
    values: { giverName, monthsCount },
  }),
  propTypes: {
    giftSubscription: PropTypes.shape({
      giverName: PropTypes.string,
      months: PropTypes.number,
    }).isRequired,
  },
})

export default connect({
  giftSubscription: 'models.me.giftSubscription',
})(RedeemSuccessModal)
